import { ProfessionalsWorkJourneyTimeLog, TimeLogStatus } from 'domain/models';
import { Badge } from 'reactstrap';

import { timeLogStatusLabel, timeLogStatusVariant } from '../helpers';

interface IProps {
  timeLog?: ProfessionalsWorkJourneyTimeLog;
}

export const WorkJourneyTimeLog = ({ timeLog }: IProps) => {
  const status = timeLog?.status || TimeLogStatus.MISSING;
  const variant = timeLogStatusVariant[status];
  const hasExtraTime = Boolean(timeLog?.extraTime);
  const label = hasExtraTime
    ? `${timeLogStatusLabel[status]} ${timeLog.extraTime}`
    : timeLogStatusLabel[status];

  return (
    <div className="d-flex flex-column">
      <strong>{timeLog?.time || '--'}</strong>
      <Badge
        color={variant}
        className={`bg-${variant}-subtle text-${variant} align-self-start fs-10 mt-1`}
      >
        {label}
      </Badge>
    </div>
  );
};
